module.exports = "/work-site/img/env.6dc4f2be.png";